// The shell's top row (owner, 2026-10-21): the section bar on the left (GroupBar or the settings
// bar) and the page's buttons on the right (PageHeader portals them into the slot). The row shows
// only while it holds something, so pages with neither start at the top. Visibility is set from
// the DOM (a MutationObserver) because the buttons arrive through a portal after the row renders.
import { useLayoutEffect, useRef, useState, type ReactNode } from "react";
import { PAGE_ACTIONS_SLOT } from "./PageHeader";

export function TopRow({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [on, setOn] = useState(false);
  useLayoutEffect(() => {
    const row = ref.current;
    if (!row) return;
    const check = () => {
      const slot = row.querySelector(`#${PAGE_ACTIONS_SLOT}`);
      setOn(Boolean(row.querySelector(":scope > nav") || (slot && slot.childElementCount > 0)));
    };
    check();
    const mo = new MutationObserver(check);
    mo.observe(row, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, []);
  return (
    <div ref={ref} className={on ? "mb-4 flex flex-wrap items-center gap-2" : "hidden"}>
      {children}
      {/* After a seated root (Marketing), the page buttons follow it instead of splitting the space. */}
      <div
        id={PAGE_ACTIONS_SLOT}
        className="ms-auto flex flex-wrap items-center gap-2 [.ady-sit-root+&]:ms-0"
      />
    </div>
  );
}
